import { Pipe, PipeTransform } from '@angular/core';
import { parseDate } from '@telerik/kendo-intl';

@Pipe({
  name: 'toDate',
  standalone: false
})
export class ToDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return parseDate(value);
  }

}
